var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zpa-form',{ref:"Form",staticStyle:{"height":"800px !important","max-height":"800px !important"},attrs:{"label-width":120}},[(_vm.data.id)?_c('form-info',{attrs:{"data":_vm.data,"canOperate":false,"checkPublic":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }